import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import PartnerForm from '@/modules/partner/components/PartnerForm.vue';
import { Partner } from '@/modules/partner/Partner';


export default /*@__PURE__*/_defineComponent({
  __name: 'PartnerCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const partner = ref<Partial<Partner>>({
	invoice: {
		target: null,
		address: '',
		zipcode: '',
		city: '',
		email: '',
	},
});

const saved = (partner) => {
	Flash.success($gettext('Återförsäljare tillagd'));
	router.push({
		name: 'partner.edit',
		params: { id: partner.id },
	});
};

const cancel = () => {
	router.push({ name: 'partner.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PartnerForm, {
    "page-title": _unref($gettext)('Ny återförsäljare'),
    partner: partner.value,
    onSaved: saved,
    onCancel: cancel,
    "for-create": true
  }, null, 8, ["page-title", "partner"]))
}
}

})